import { render, staticRenderFns } from "./blessingTiger.vue?vue&type=template&id=438e01ca&scoped=true"
import script from "./blessingTiger.vue?vue&type=script&lang=js"
export * from "./blessingTiger.vue?vue&type=script&lang=js"
import style0 from "./blessingTiger.vue?vue&type=style&index=0&id=438e01ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e01ca",
  null
  
)

export default component.exports